/* GENERATED FILE — DO NOT EDIT.
 *
 * Source: brand/brand.json
 * Regenerate: npm run brand   (or: node brand/generate.mjs)
 *
 * Edits here are overwritten. Change brand.json instead — that is the whole point
 * of this file existing: the product name and palette live in exactly one place,
 * so renaming or re-theming is one edit rather than an archaeology exercise.
 */

export const brand = {
  name: "Dadoo Deals",
  shortName: "DadooDeals",
  slug: "dadoodeals",
  tagline: "Pay less, get more, at places you already love.",
  description: "Buy a voucher for less than it is worth, then spend it at the counter.",
  legalEntity: "DADOODEALSCLUB LLC",
  copyrightFrom: 2026,

  supportEmail: "info@dadoodeals.com",
  supportPhone: "",

  /* Who operates the service, and how long a reply takes. Named on the support
     page because an app-store reviewer opens it cold and rejects listings that
     do not say who is behind the app. Placeholder values until the client
     supplies their own - see brand.json. */
  operatorAddress: "1 Jacobs Landing Way, Secaucus, New Jersey 07094, USA",
  supportReplyTime: "within 1 business day",

  urls: {
    shop: "https://www.dadoodeals.com",
    console: "https://console.dadoodeals.com",
    admin: "https://admin.dadoodeals.com",
    terms: "https://www.dadoodeals.com/terms",
    privacy: "https://www.dadoodeals.com/privacy",
  },

  currency: "USD",
  currencySymbol: "$",
  language: "en-US",

  /* The phone apps' ids as the SERVER knows them: their iOS bundle ids, permanent
     once uploaded. Each app passes its own when it registers for push, on iOS AND
     Android, so the server addresses the token with the right app (and, on iOS, the
     right APNs topic). The Android package names differ (brand.json androidPackages)
     and are deliberately not emitted here: only app.config.ts needs them, and the
     server refuses them as an AppId. */
  appIds: {
    buyer: "com.dadoodealsclub.app",
    seller: "com.dadoodealsclub.business",
  },
} as const;

/**
 * Money formatting, in one place.
 *
 * Takes CENTS, because that is what the API returns and what the domain uses —
 * there is no decimal money type anywhere in this system. Any component doing its
 * own `/ 100` is a rounding bug waiting for a currency with a different exponent.
 */
export function formatMoney(cents: number): string {
  return new Intl.NumberFormat(brand.language, {
    style: 'currency',
    currency: brand.currency,
  }).format(cents / 100);
}
